import axios from 'axios';
import i18n from '../config/i18n';
import { getToken } from '../utils/auth';
import { logout } from '../store/slices/auth/authSlice';
import { getStore } from '../utils/storeInjector';

export const HEADER_LANGUAGE_TYPE = Object.freeze({
  DEFAULT: 'DEFAULT',
  SINGLE_LANGUAGE: 'SINGLE_LANGUAGE'
});

const baseURL = import.meta.env.VITE_API_BASE_URL || 'https://api.seven7g.com/api/v1';
/**
 * Central Axios instance
 */
const apiClient = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    // 'ngrok-skip-browser-warning': 'true',
    'ngrok-skip-browser-warning': '69420',
    modes: 'CORS'
  },

  responseType: 'json'
});

/**
 * Request Interceptor
 * - Attach auth token
 * - Modify request if needed
 */
apiClient.interceptors.request.use(
  (config) => {
    const lang = localStorage.getItem('i18nextLng')    
    const token = getToken();

    // Handling Token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }else{
      
    }
    
    // Handling form data
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    } else {
      config.headers['Content-Type'] = 'application/json';
    }    

    //Handling Language Header
    if (config.HEADER_TYPE === HEADER_LANGUAGE_TYPE.SINGLE_LANGUAGE) {
      config.headers['accept-language'] = lang;
    } else {
      config.headers['user-agents'] = 'AdminWeb';
    }

    // Handling CORS
    config.headers['ngrok-skip-browser-warning'] = '69420';
    config.headers['modes'] = 'CORS';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response Interceptor
 * - Handle global errors
 * - Normalize responses
 */
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const { config, response } = error;
    const status = response?.status;

    if (status === 404 && config.handle404Silently && response.data) {
      console.warn('Resource not found, but handled as empty state:', config.url);
      return Promise.resolve({
        error: response.error,
        data: [],
        isNotFound: true,
        message: response.data.message || 'Data missing'
      });
    }

    if (status === 404) {
      return Promise.reject(error);
    }

if (response?.status === 401) {
      const store = getStore(); // Retrieve the injected store

      if (store && typeof store.dispatch === 'function') {
        // Use the string type or import the action
        store.dispatch({ type: 'auth/logout' });
      } else {
        // If the store is STILL not ready (rare), fallback to manual cleanup
        localStorage.clear();
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

function errorResponseHandling(response) {
  if (response.status === 404) {
    return 'Data not found on this section';
  }
}

export default apiClient;
